import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import MACTeHomepage from './pages/HomePage';
import Layout from './layout/Layout';
import './css/global.css';
import SingleEventPage from './pages/SingleEventPage';
import EventsPage from './pages/EventsPage';
import PastEventsPage from './pages/PastEventsPage';
import CollectionsPage from './pages/CollectionsPage';
import DecouvrirMACTe from './pages/DecouvrirMACTe';
import VisitPage from './pages/VisitPage';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import MentionsLegales from './pages/MentionsLegales';
import VieAdministrative from './pages/VieAdministrative';
import MagazinePage from './pages/MagazinePage';
import SinglePatrimoineActualitePage from './pages/SinglePatrimoineActualitePage';
import PatrimoineActualitesPage from './pages/PatrimoineActualitesPage';
import LocationsEspaces from './pages/LocationsEspaces';
import ProjetOrientationP1 from './pages/ProjetOrientationP1';
import ProjetOrientationP4 from './pages/ProjetOrientationP4';
import RestaurantPage from './pages/RestaurantPage';
import NewsletterKiosk from './pages/NewsletterKiosk';
import VisiteIle from './pages/visite/VisiteIle';
import AdminPage from './pages/AdminPage';
import AdminLayout from './pages/admin/AdminLayout';
import AdminCollections from './pages/admin/AdminCollections';
import AdminEvents from './pages/admin/AdminEvents';
import AdminHiringAds from './pages/admin/AdminHiringAds';
import AdminMagazines from './pages/admin/AdminMagazines';
import AdminPatrimoine from './pages/admin/AdminPatrimoine';
import AdminPopups from './pages/admin/AdminPopups';
import AdminSettings from './pages/admin/AdminSettings';
import AdminMenuPage from './pages/admin/AdminMenuPage';
import SpecialMenuPage from './pages/SpecialMenuPage';
import AdminFooter from './pages/admin/AdminFooter';
import AdminPages from './pages/admin/AdminPages';
import AdminUsers from './pages/admin/AdminUsers';
import AdminDashboard from './pages/admin/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Handle both the root and the custom path */}
          <Route index element={<MACTeHomepage />} />
          {/* <Route path="/app-x7d92h.html" element={<MACTeHomepage />} /> */}
          <Route path="/accueil" element={<MACTeHomepage />} />
          <Route index element={<MACTeHomepage />} />
          <Route path="/evenement/:eventId" element={<SingleEventPage />} />
          <Route path="/evenements" element={<EventsPage />} />
          <Route path="/evenements-passes" element={<PastEventsPage />} />
          <Route path="/collections" element={<CollectionsPage />} />
          <Route path="/decouvrir-le-macte" element={<DecouvrirMACTe />} />
          <Route path="/visiter-le-macte" element={<VisitPage />} />
          <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/annonces-legales" element={<VieAdministrative />} />
          <Route path="/magazines" element={<MagazinePage />} />
          <Route path="/patrimoine-actualites" element={<PatrimoineActualitesPage />} />
          <Route path="/patrimoine-actualites/:articleId" element={<SinglePatrimoineActualitePage />} />
          <Route path="/locations-espaces" element={<LocationsEspaces />} />
          <Route path="/projet-racines-en-mouvement" element={<ProjetOrientationP1 />} />
          <Route path="/projet-memorial-vision" element={<ProjetOrientationP4 />} />
          <Route path="/restaurant-ichali" element={<RestaurantPage />} />
          <Route path="/exposition-speciale" element={<SpecialMenuPage />} />
        </Route>
        {/* Page kiosque newsletter - sans layout */}
        <Route path="/newsletter" element={<NewsletterKiosk />} />
        {/* Audioguide NFC - page d'une île, sans layout */}
        <Route path="/visite/:ileId" element={<VisiteIle />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="collections" element={<AdminCollections />} />
          <Route path="events" element={<AdminEvents />} />
          <Route path="hiring-ads" element={<AdminHiringAds />} />
          <Route path="magazines" element={<AdminMagazines />} />
          <Route path="patrimoine-actualites" element={<AdminPatrimoine />} />
          <Route path="popups" element={<AdminPopups />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="menu-page" element={<AdminMenuPage />} />
          <Route path="menu" element={<Navigate to="/admin/menu-page" replace />} />
          <Route path="footer" element={<AdminFooter />} />
          <Route path="pages" element={<AdminPages />} />
          <Route path="users" element={<AdminUsers />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;